import React from 'react';

interface IOwnProps {
    name: string;
    classModifier?: string;
    isV2?: boolean;
}

type Props = IOwnProps;

class Icon extends React.Component<Props, {}> {
    public render() {
        return <svg className={`svg-icon svg-icon--${this.props.name}${this.props.classModifier ? ` ${this.props.classModifier}` : ''}`}>
            <use xlinkHref={`/dist/svg/svg-sprite${this.props.isV2 ? '-v2' : ''}.svg#` + this.props.name} />
        </svg>;
    }
}

export default Icon;